module.exports = __webpack_public_path__ + "img/children-2.38ddec91.jpg";